import AmexShopSmallSelector from './AmexShopSmallSelector';

export default AmexShopSmallSelector;
